import { useStrategiesContext } from '../StrategiesContext';

import { Grid } from '../Grid';
import { List } from '../List';
import { useUserStrategies } from '../../../context/UserStrategies';
import PlaceholderWidget from '../../Widget/Placeholder/Placeholder';

export const View = () => {
  const { strategies } = useUserStrategies();
  const { mode } = useStrategiesContext();

  return strategies.length === 0 ? (
    <PlaceholderWidget height={2} width={2} />
  ) : mode === 'viewList' ? (
    <List />
  ) : (
    <Grid />
  );
};
